<template>
  <div class="clearfix ui_checkselect"
       :class="{ disabled: !!disabled, readonly: !!readonly, error: modelError, full: full }"
       :style="{ width: computedWidth, height: computedHeight }"
       @scroll.stop>
    <div class="item--wrap">
      <p class="selected-item"
         v-if="!full" :style="{ width: renderedWidth + 'px' }"
         @click.stop="toggleList">
        <span class="placeholder"
              v-if="placeholder && activeItems.length < 1"
              v-html="placeholder"></span>
        <span class="selected" v-if="!isAllSelected" :ref="'selected'">
          <span class="label"
                v-for="(item, index) in activeItems" :key="'active' + index"
                @click.stop="onChange(item)">
            {{ item.value || item }} <i class="icon icon--close-label"></i></span>
        </span>
        <span class="label" v-else-if="selectAll" @click="removeAllItems">
          {{ $t('common.all') }}<i class="icon icon--close-label"></i></span>
        <span class="count" v-if="selectedOverflowCount">+ {{ selectedOverflowCount }}</span>
        <i class="icon icon--drop-down"
           v-if="!disabled && !readonly"
           :class="{'is-show': showList}"></i>
      </p>
      <transition name="slide" v-if="!disabled && !readonly">
        <div class="item__list" :style="{ width: computedWidth, height: computedMaxHeight }"
             :class="{'is-show': showList || full}"
             v-show="showList || full">
          <div class="item__search" v-if="search">
            <input v-model.trim="keyword">
            <i class="icon icon--search"></i>
          </div>
          <div class="item__search gap" v-else-if="showCount"></div>
          <div class="item__all_check">
<!--            <ui-checkbox :value="userAllSelect" @input="onUserAllCheck">{{ $t('common.allSelect') }}</ui-checkbox>-->
            <ui-checkbox :value="isAllSelected || isSearchAllSelected" @input="onSelectAll" :disabled="disableCheckbox" :unselect="unselect || searchUnSelect">
              <template v-if="!keyword">{{ $t('common.allSelect') }}</template>
              <template v-else>{{ $t('common.allSelectForSearch') }}</template>
            </ui-checkbox>
          </div>
          <div v-if="showCount"
               class="item__count">
            <span class="number" v-if="keyword">{{ getSelectedCountByKeyword() | thousand }}</span>
            <span class="number" v-else>{{ activeItems.length | thousand }}</span>
            {{ $t('common.selected') }}
          </div>
          <ul>
<!--            <li class="item__category-item" v-if="!keyword && selectAll">-->
<!--              <span class="item-category">{{ $t('common.all') }}</span>-->
<!--              <ul class="item__category-list">-->
<!--                <li class="item__list-item" @click="onSelectAll" :disabled="disableCheckbox">-->
<!--                  <ui-checkbox :value="isAllSelected">{{ $t('common.all') }}</ui-checkbox>-->
<!--                </li>-->
<!--              </ul>-->
<!--            </li>-->
<!--            <li class="item__category-item" v-if="!keyword && unSelectAll">-->
<!--              <ul class="item__category-list">-->
<!--                <li class="item__list-item" @click="removeAllItems" >-->
<!--                  <ui-checkbox :value="isNoneSelected" :disabled="disableCheckbox">{{ $t('common.selectNone') }}</ui-checkbox>-->
<!--                </li>-->
<!--              </ul>-->
<!--            </li>-->
            <li class="item__category-item"
                v-for="(item, index) in selectItems" :key="index" v-show="!keyword || item.show">
              <span class="item-category" v-if="item.text">
                <text-highlight :searchKeyword="keyword"
                                :textItem="getItemText(item)"></text-highlight>
              </span>
              <ul class="item__category-list" v-if="item.items">
                <li class="item__list-item"
                    :class="{ 'txt-blue': isBlankValue(itm.value),
                              'full': itm.desc }"
                    v-for="(itm, idx) in item.items" :key="idx"
                    @click="onChange(itm.value, itm.disabled || disableCheckbox)">
                  <div class="item-wrap"
                       v-if="!keyword || searchItems.includes(itm.value)">
                    <ui-checkbox ref="countryCheckbox"
                                 :value="isSelected('ALL') || (isSelected(itm.value))"
                                 :disabled="itm.disabled || disableCheckbox">
                      <ui-tooltip v-if="!isBlankValue(itm.value) && !itm.desc && itm.showText.length > 19"
                                  arrowBottom
                                  arrowCenter>
                        <text-highlight :searchKeyword="keyword"
                                        :textItem="itm.showText"></text-highlight>
                      </ui-tooltip>
                      <span class="label-text">
                        <text-highlight :searchKeyword="keyword"
                                        :textItem="itm.showText"></text-highlight>
                        <span class="desc" v-if="itm.desc"
                              v-html="itm.desc"></span>
                      </span>
                    </ui-checkbox>
                  </div>
                </li>
              </ul>
            </li>
            <li class="item__empty"
                v-if="keyword && !searchCount">
              <i class="icon icon--empty"></i><br>
              {{ $t('dashboard.noApplies.searchResult.title') }}
            </li>
          </ul>
        </div>
      </transition>
    </div>
    <strong v-if="modelError" class="validation-text">{{ $t(`common.validationErrorText.${modelError}`) }}</strong>
  </div>
</template>

<script>
import { EventBus } from '@/libs/event-bus'
import { isPlainObject } from '@/libs/utils'
import UiCheckbox from './UiCheckbox'
import UiTooltip from './UiTooltip'
import TextHighlight from './TextHighlight'

export default {
  name: 'UiCheckSelectbox',
  components: {
    UiCheckbox,
    TextHighlight,
    UiTooltip
  },
  props: [
    'value',
    'items',
    'full',
    'height',
    'width',
    'maxHeight',
    'title',
    'disabled',
    'readonly',
    'modelError',
    'search',
    'unSelectAll',
    'selectAll',
    'placeholder',
    'disableCheckbox',
    'showCount',
    'unselectLastOne'
  ],
  data () {
    return {
      showList: false,
      renderedWidth: 0,
      itemCount: 0,
      keyword: '',
      searchCount: 0,
      searchCheckedCount: 0,
      activeItems: [],
      searchItems: [],
      selectedHeight: 0,
      selectedInlineCount: 0,
      selectedOverflowCount: 0,
      userAllSelect: false,
      unselect: false,
      searchUnSelect: false
    }
  },
  watch: {
    keyword () {
      this.setSearchItems()

      if (!this.keyword) {
        this.searchUnSelect = false
        if (this.isAllSelected) {
          this.unselect = false
        } else {
          if (this.activeItems.length > 0) {
            this.unselect = true
          }
        }
      }
    },
    showList (value) {
      const isChild = function (obj, parentObj) {
        while (obj !== undefined && obj !== null && obj.tagName.toUpperCase() !== 'BODY') {
          if (obj === parentObj) {
            return true
          }
          obj = obj.parentNode
        }
        return false
      }
      let listener = (event) => {
        if (!isChild(event.target, this.$el)) {
          this.showList = false
        }
      }

      let dimmed = document.getElementsByClassName('dimmed')
      if (value) {
        document.body.addEventListener('click', listener, false)
        Array.from(dimmed).forEach(v => {
          v.addEventListener('click', listener, false)
        })
      } else {
        document.body.removeEventListener('click', listener)
        Array.from(dimmed).forEach(v => {
          v.removeEventListener('click', listener, false)
        })
      }
    },
    activeItems () {
      if (this.$refs.selected) {
        setTimeout(() => { this.touchSelectedHeight() }, 200)
      }
    }
  },
  computed: {
    computedWidth () {
      if (!this.width && this.renderedWidth) {
        return this.renderedWidth + 'px'
      } else if (typeof this.width === 'number') {
        return this.width + 'px'
      }
      return this.width
    },
    computedHeight () {
      return this.height
    },
    computedMaxHeight () {
      if (this.full) {
        return this.computedHeight
      }
      if (typeof this.maxHeight === 'number') {
        return (this.maxHeight - 38) + 'px'
      }
      return 'calc(' + this.maxHeight + ' - 38px)'
    },
    selectItems () {
      return this.items.map(item => {
        if (!isPlainObject(item)) {
          return {
            value: item
          }
        }
        return item
      })
    },
    isSearchAllSelected () {
      return this.getSelectedCountByKeyword() === this.searchCount && this.keyword && this.searchCount !== 0
    },
    isAllSelected () {
      return this.activeItems.length === this.itemCount
    },
    isNoneSelected () {
      return this.activeItems.length === 0
    }
  },
  mounted () {
    this.renderedWidth = this.$el.offsetWidth
    EventBus.$on('closeAllUiSelectBox', () => {
      this.showList = false
    })
  },
  created () {
    if (this.value) {
      if (Array.isArray(this.value)) {
        this.value.map(item => {
          this.activeItems.push(item)
          this.touchSelectedHeight()
        })
      } else {
        this.activeItems.push(this.value)
      }
    }
    this.items.map(item => {
      item.show = true
      item.items.map(itm => {
        itm.disabled = false
        if (itm.desc) {
          itm.showText = itm.text || itm.value || ''
        } else {
          itm.showText = !this.isBlankValue(itm.value) ? itm.value : ''
          if (itm.text && itm.value !== itm.text) {
            itm.showText += ' '
            if (!this.isBlankValue(itm.value)) {
              itm.showText += '['
            }
            itm.showText += this.getItemText(itm)
            if (!this.isBlankValue(itm.value)) {
              itm.showText += ']'
            }
          }
        }
      })
    })

    this.selectItems.map(item => {
      this.itemCount += item.items.length
    })

    if (!this.isAllSelected) {
      if (this.activeItems.length > 0) {
        this.unselect = true
      }
    }

    if (this.isSelected('ALL')) {
      this.onDisableAll(true)
    }
  },
  methods: {
    getSelectedCountByKeyword () {
      const keyword = this.keyword
      let countItems = 0
      this.selectItems.map(item => {
        const category = this.getItemText(item).toLowerCase()
        item.items.map(itm => {
          const value = itm.value ? itm.value.toLowerCase() : itm.value
          const text = this.getItemText(itm).toLowerCase()
          if ((category && category.indexOf(keyword) !== -1) || (value && value.indexOf(keyword) !== -1) || (text && text.indexOf(keyword) !== -1)) {
            if (this.isSelected(itm.value)) {
              countItems = countItems + 1
            }
          }
        })
      })
      return countItems
    },

    isBlankValue (value) {
      return !value || value === '__blank__' || value === '__null__'
    },
    touchSelectedHeight () {
      if (!this.full) {
        const formerHeight = this.selectedHeight
        this.selectedHeight = this.$refs.selected.clientHeight

        if (formerHeight < 40 && formerHeight < this.selectedHeight) {
          this.selectedInlineCount = this.activeItems.length
        } else if (formerHeight > 40 && formerHeight > this.selectedHeight) {
          this.selectedOverflowCount = 0
        }

        if (this.selectedHeight > 40) {
          this.selectedOverflowCount = this.activeItems.length - this.selectedInlineCount + 1
        }
      }
    },
    toggleList () {
      if (this.disabled) {
        return
      }
      EventBus.$emit('closeUserMenu')
      EventBus.$emit('closeDateRangePicker')
      EventBus.$emit('closeReferrerList')
      EventBus.$emit('closeReportPageList')
      if (!this.showList) {
        EventBus.$emit('closeAllUiSelectBox')
      }
      this.showList = !this.showList
    },
    onChange (value, disabled = false) {
      if (!disabled) {
        if (this.isSelected(value)) {
          this.removeItem(value)
        } else {
          this.activeItems.push(value)
        }

        if (!this.isAllSelected && !this.isNoneSelected) {
          this.unselect = true
        } else {
          this.unselect = false
        }

        if (this.keyword) {
          if (this.getSelectedCountByKeyword() === this.searchCount || this.getSelectedCountByKeyword() === 0) {
            this.searchUnSelect = false
            this.unselect = false
          }
        }

        this.$emit('input', this.activeItems)
        this.$emit('changed')
      }
    },
    getItemText (item) {
      if (!item) {
        return ''
      }
      return String(item.i18n || (item.text && item.text[this.$i18n.locale] ? item.text[this.$i18n.locale] : (item.text || item.value || '')))
    },
    removeItem (item) {
      const idx = this.activeItems.indexOf(item)
      if (idx >= 0) {
        this.activeItems.splice(idx, 1)
      }
    },
    removeAllItems () {
      if (!this.disableCheckbox) {
        this.activeItems = []
        this.$emit('input', this.activeItems)
        this.$emit('changed')
      }
    },
    isSelected (item) {
      return this.activeItems.includes(item)
    },

    onDisableAll (disabled) {
      this.items.map(item => {
        item.items.map(itm => {
          if (itm.value !== 'ALL') {
            itm.disabled = disabled
          }
        })
      })
    },
    onSelectAll () {
      const keyword = this.keyword
      if (!this.disableCheckbox) {
        if (keyword) {
          const searchItems = []
          this.selectItems.map(item => {
            const category = this.getItemText(item).toLowerCase()
            item.items.map(itm => {
              const value = itm.value ? itm.value.toLowerCase() : itm.value
              const text = this.getItemText(itm).toLowerCase()
              if ((category && category.indexOf(keyword) !== -1) || (value && value.indexOf(keyword) !== -1) || (text && text.indexOf(keyword) !== -1)) {
                searchItems.push(itm)
              }
            })
          })

          let selected = false
          if (!this.isSearchAllSelected) {
            selected = true
          }

          searchItems.forEach(item => {
            this.removeItem(item.value)
            if (selected) {
              this.activeItems.push(item.value)
            }
          })
        } else {
          if (!this.isAllSelected) {
            this.removeAllItems()
            this.selectItems.map(item => {
              item.items.map(itm => {
                this.activeItems.push(itm.value)
              })
            })
          } else {
            this.removeAllItems()
          }
        }

        this.unselect = false
        this.searchUnSelect = false
      }

      this.$emit('input', this.activeItems)
      this.$emit('changed')
    },
    setSearchItems () {
      let items = []
      let keyword = this.keyword.toLowerCase()
      this.searchCount = 0
      let checkedItems = 0
      this.selectItems.map(item => {
        const category = this.getItemText(item).toLowerCase()
        let countItems = 0

        item.items.map(itm => {
          const value = itm.value ? itm.value.toLowerCase() : itm.value
          const text = this.getItemText(itm).toLowerCase()
          if ((category && category.indexOf(keyword) !== -1) || (value && value.indexOf(keyword) !== -1) || (text && text.indexOf(keyword) !== -1)) {
            items.push(itm.value)
            if (this.isSelected(itm.value)) {
              checkedItems = checkedItems + 1
            }
            countItems = countItems + 1
          }
        })
        this.searchCount = this.searchCount + countItems
        if (!countItems) {
          item.show = false
        } else {
          item.show = true
        }

        if (checkedItems === this.searchCount) {
          this.searchUnSelect = false
          this.unselect = false
        } else {
          if (checkedItems) {
            this.searchUnSelect = true
          } else {
            this.searchUnSelect = false
          }
        }
      })
      this.searchItems = items
    }
  }
}
</script>

<style lang="scss">
.ui_checkselect {
  text-align: left;
  display: inline-block;
  height: 39px;
  position: relative;

  &.disabled {
    pointer-events: none;
    .item--wrap{
      background-color:#d7d7d7;
      opacity: 0.3;
    }
  }

  &.error {
    .validation-text {
      color: $errorColor;
    }
  }

  &.readonly {
    pointer-events: none;
    .item--wrap{
      border: solid 1px #d7d7d7;
      background-color: #e6e6e6;
    }
  }

  &.full .item--wrap {
    border-radius: 0;
    background: transparent;
    border: none;

    .item__list {
      border-radius: 5px;
      border: 1px solid #d7d7d7;
      background-color: #f4f4f4;
    }
  }

  .item--wrap {
    position: relative;
    display: inline-block;
    width: 100%;
    line-height: 36px;
    border-radius: 6px;
    border: solid 1px #bbbbbb;
    background-color: #ffffff;
    box-sizing: border-box;
    font-size: 14px;
    color: #2f2f2f;
    z-index: 10;

    .selected-item {
      color: #2f2f2f;
      position: relative;
      height: 38px;
      overflow: hidden;
      width: 100%;
      box-sizing: border-box;
      padding: 0 60px 0 8px;
      cursor: pointer;

      .selected {
        display: inline-block;

        .label {
          display: inline-block;
          white-space: nowrap;
          margin-right: 8px;
          padding: 0 8px;
          line-height: 23px;
          border-radius: 15px;
          background: #ebebeb;
          transform: translateY(1px);

          .icon {
            margin-left: 5px;
            transform: translateY(1px);
          }
        }
      }

      .placeholder {
        display: inline-block;
        color: #bbbbbb;
        font-size: 14px;
        padding: 1px 0 0 5px;
      }

      .count {
        position: absolute;
        top: 50%;
        right: 40px;
        transform: translateY(-50%);
        color: #fff;
        background: #ec0047;
        font-size: 12px;
        border-radius: 15px;
        line-height: 18px;
        padding: 0 5px;
        min-width: 15px;
        text-align: center;
      }

      .icon--drop-down {
        position: absolute;
        top: 50%;
        right: 12px;
        transform: translateY(-50%);
        cursor: pointer;
        z-index: 10;
        transition: transform 0.2s ease;

        &.is-show {
          transform: translateY(-50%) scaleY(-1);
        }
      }
    }

    .item__list {
      position: relative;
      box-sizing: border-box;
      padding: 0 20px;
      overflow-y: auto;
      background-color: #fff;
      z-index: 10;
      border-bottom-right-radius: 6px;
      border-bottom-left-radius: 6px;
      border-top: 1px solid #bbbbbb;
      opacity: 0;
      transform-origin: top;
      transition: transform .2s ease, opacity .1s ease, height .2s ease;

      &.is-show {
        opacity: 1;
      }

      .item__search {
        position: relative;
        margin: 13px 0;
        height: 34px;

        input {
          width: 244px;
          height: 34px;
          padding: 0 13px;
          line-height: 34px;
          border: 1px solid #bbbbbb;
          color: #999999;
          border-radius: 20px;
          -webkit-appearance: none;

          &::-ms-clear {
            display: none;
          }
          &::-ms-reveal {
            display: none;
          }
        }

        .icon {
          position: absolute;
          top: 9px;
          left: 245px;
        }
      }

      .item__all_check {
        position: absolute;
        top: 13px;
        left: calc(50% - 18px);
        font-size: 13px;
        color: #666666;

        .number {
          color: #ec0047;
          font-weight: 600;
          font-size: 15px;
        }
      }

      .item__count {
        position: absolute;
        top: 13px;
        right: 20px;
        font-size: 13px;
        color: #666666;

        .number {
          color: #ec0047;
          font-weight: 600;
          font-size: 15px;
        }
      }

      .item__category-list {
        margin: 10px 0 15px 0;

        &::after {
          clear: both;
          display: block;
          content: "";
        }
      }

      .item__category-item {
        .item-category {
          @include textEllipsis;
          display: block;
          white-space: nowrap;
          overflow: hidden;
          height: 28px;
          line-height: 28px;
          background-color: #e6e6e6;
          font-size: 13px;
          text-align: center;
        }
      }

      .item__list-item {
        .item-wrap {
          color: #444;
          float: left;
          width: 25%;
          height: 30px;
        }

        &.txt-blue {
          .item-wrap {
            color: #0e90a5;
            width: 50%;
          }
        }

        .ui_checkbox {
          margin-left: 0;

          .bubble {
            position: absolute;
            bottom: 27px;
            left: 50%;
            transform: translate(-50%, 20%);
            padding: 16px 16px 6px 16px;
            width: 100%;
            transition: transform 0.2s cubic-bezier(.28,.12,.42,.94),
            z-index 0.2s ease 0.2s,
            opacity 0.2s ease;
            opacity: 0;
            z-index: -1;

            .text {
              white-space: normal;
              word-break: break-all;
              margin: 0;
              font-size: 12px;
              color: #444444;
              display: inline-block;
            }
          }

          &:hover {
            .bubble {
              transform: translate(-50%, 0);
              opacity: 1;
              z-index: 1;
              transition: transform 0.2s cubic-bezier(.28,.12,.42,.94),
              opacity 0.2s ease;
            }
          }

          .text {
            color: inherit;
          }

          .label-text {
            @include textEllipsis;
            display: inline-block;
            width: calc(100% - 30px);
            white-space: nowrap;
            overflow: hidden;
            height: 26px;
            font-size: 12px;
            margin-bottom: -3px;
            padding-right: 5px;
          }
        }

        .item-name {
          @include textEllipsis;
          display: block;
          margin-right: 10px;
          white-space: nowrap;
          overflow: hidden;
        }

        &.full {
          .item-wrap {
            position: relative;
            width: calc(100% - 71px);
            margin: 0 0 15px 45px;

            &:before {
              content: "";
              position: absolute;
              top: calc(50% + 2px);
              left: 30px;
              border-bottom: 1px dashed #b0b0b0;
              width: calc(100% - 110px);
              z-index: -1;
            }

            .ui_checkbox {
              position: relative;

              .label-text {
                width: calc(100% - 50px);
                font-size: 13px;

                span {
                  display: inline-block;
                  background-color: #f4f4f4;
                  padding-right: 20px;
                }

                .desc {
                  width: 55px;
                  float: right;
                  text-align: right;
                  background-color: #f4f4f4;
                }
              }
            }
          }
        }
      }

      .item__empty {
        @include positionXYcenter;
        font-size: 13px;
        color: #767676;
        margin-top: 30px;
        text-align: center;

        .icon {
          margin-bottom: -12px;
        }
      }
    }
  }

  &.full .item__empty {
    margin-top: 0 !important;
  }

  .validation-text {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    padding-left: 5px;
    font-weight: 600;
  }
}
.slide-enter, .slide-leave-to{
  height: 0 !important;
}
</style>
